import { ServerSidePropsContext } from 'providers/ServerSideProps';
import React from 'react';
import {
  ButtonDefault,
  Container,
  MainPrice,
  MainTitle,
  SubText,
} from './RestrictedBanner.styled';

const restrictedStrings = {
  mainTitle: 'Assine <strong>O Popular digital</strong>',
  mainPrice: '<span>R$ <strong>4,90</strong></span> <span>mensais</span>',
  buttonText: 'Assine Agora',
  buttonLink: '/assine',
  subText:
    'Desconto para assinatura <strong>digital</strong> nos três primeiros meses.',
};

type RestrictedBannerProps = {
  bannerData: any;
  priceValue: string;
};
const RestrictedBanner: React.FC<RestrictedBannerProps> = ({
  priceValue,
  bannerData,
}) => {
  const serverSideContext = React.useContext(ServerSidePropsContext);
  const isPaywall =
    serverSideContext?.site?.pageConfig?.featureRadioSelectPaywall;
  const valor = bannerData?.valor?.toString().replace('.', ',');
  const mainPriceString: string =
    `<span>R$ <strong>${
      valor?.length < 4 ? valor + '0' : valor
    }</strong></span> <span>${bannerData.condicaoPagamento}</span> ` ||
    restrictedStrings.mainPrice.replace('%PRICE_VALUE%', priceValue);
  return (
    <Container backGround={bannerData.corBackground}>
      <MainTitle color={bannerData.corTexto}>
        {bannerData.chamadaLoja}
      </MainTitle>
      <MainPrice color={bannerData.corTexto}>{mainPriceString}</MainPrice>
      <ButtonDefault
        color={bannerData.corTexto}
        url={
          isPaywall === 'PIANO'
            ? restrictedStrings.buttonLink
            : process.env.NEXT_PUBLIC_URL_LOJA || ''
        }
      >
        {restrictedStrings.buttonText}
      </ButtonDefault>
      <SubText color={bannerData.corTexto}>{bannerData.textoCondicao}</SubText>
    </Container>
  );
};

RestrictedBanner.defaultProps = {
  priceValue: '4,90',
};

export default RestrictedBanner;
